<template>
        <div 
            class="productMenu" 
            :style="'padding-left:'+paddingLeft"
            :class="{ 'productMenuVisible': true }"
        >
            <div class="menuBody" :style="customWidth">
                <div style="margin-right: 10px;">
                    <Button style="color: steelblue; border: 1px solid steelblue" severity="contrast" icon="pi pi-home" outlined :label="screenWidth < 700 ? '' : $t('buttons.home')" @click="$router.push({name:'shopLanding'})" />
                </div>
                <div class="btns">
                    <IconField>
                        <InputIcon class="pi pi-search" />
                        <InputText class="searchInput" v-model="searchWordString" :placeholder="$t('buttons.search')" />
                    </IconField>
                    <Button severity="contrast" icon="pi pi-search" :label="screenWidth < 700 ? '' : $t('buttons.searchShort')" @click="$emit('searchProduct', searchWordString)" v-if="searchWordString" />
                </div>
                <div class="btnsRight">
                    <!-- <div>
                        <Button  severity="contrast" icon="pi pi-sliders-v" label="Filtreeri" outlined @click="$emit('openCartSidebar')" />
                    </div> -->
                    <div>
                        <Button  severity="contrast" style="color: steelblue; border: 1px solid steelblue" icon="pi pi-envelope" :label="screenWidth < 755 ? '' : $t('buttons.contactUs')" outlined @click="$emit('openContactPopup')" />
                    </div>
                    <div>
                        <Button  severity="contrast" style="color: steelblue; border: 1px solid steelblue" icon="pi pi-send" :label="screenWidth < 700 ? '' : $t('buttons.shippingOptions')" outlined @click="$emit('showShippingProfileDrawer')" />
                    </div>
                    <div>
                        <Button  severity="contrast" style="background-color: steelblue; border: 1px solid steelblue" icon="pi pi-shopping-cart" :badge="shoppingCartInv" :label="screenWidth < 700 ? '' : $t('buttons.cart')" @click="$emit('openCartSidebar')" />
                    </div>
                </div>
                <!-- <div class="menuLinks">
                    <p>Avaleht</p>
                    <p @click="$router.push({ name: 'catalogPage' })">Kataloog</p>
                    <p>Tarneinfo</p>
                </div> -->
            </div>
        </div>
</template>

<script>
import Button from 'primevue/button';
import IconField from 'primevue/iconfield';
import InputIcon from 'primevue/inputicon';
import InputText from 'primevue/inputtext';

export default {
    name: 'catalogMenu',
    components: {
        Button,
        IconField,
        InputIcon,
        InputText
    },
    props: {
        shopData: null,
        listingsData: Array,
        feedbackStats: Object,
        backgroundColor: {
            default: '#FFFFF'
        },
        customWidth: {
            default: 'width: 1300px'
        },
        paddingLeft: {
            default: '0px'
        },
        shoppingCartInv: {
            default: 0
        },
        screenWidth: null
    },
    data() {
        return {
            searchWordString: null
        };
    },
    watch: {
        // listingsData: {
        //     handler(newVal) {
        //         if (newVal) {
        //             this.listingCategories();
        //         }
        //     },
        //     immediate: true,
        //     deep: true
        // }
    },
    methods: {
        
    },

    created() {
        
    }
};
</script>

<style scoped>
.productMenu {
    position: fixed;
    z-index: 1050;
    top: -165px;
    left: 0px;
    width: 100%;
    border-bottom: 1px solid #eee;
    height: -webkit-fit-content;
    height: -moz-fit-content;
    height: fit-content;
    background: white;
    padding-top: 10px;
    padding-bottom: 10px;
}
.productMenuVisible {
    top: 0px;
}

.productMenuVisible.vue-fixed-header--isFixed {
    width: 100%;
    position: fixed;
    left: 0;
    top: 0px;
    z-index: 1050;
}
.menuBody {
    position: relative;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    width: 100%;
    row-gap: 10px;
    width: 1300px;
    margin: 0 auto;
}
.backArrow {
    position: absolute;
    left: -50px;
    top: 0;
    bottom: 0;
    margin: auto;
    height: 25px;
    width: 42px;
    cursor: pointer;
}
.coverImg {
    height: 70px;
}
#idCoverImg {
    display: none;
}
.identity {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
}
.name {
    margin-top: 0px;
    margin-left: 15px;
}
.name h2 {
    margin: 0;
    margin-top: 13px;
    margin-bottom: -3px;
    height: 26px;
    font-family: 'quicksand', sans-serif;
    font-weight: 500;
    font-size: 1.5rem;
    color: rgb(50,50,50);
    cursor: pointer;
    width: -webkit-fit-content;
    width: -moz-fit-content;
    width: fit-content;
}
.name p {
    margin: 0;
    margin-top: 7px;
    margin-left: 3px;
    color: rgb(50,50,50);
    font-weight: 400;
    font-size: 1rem;
    font-family: 'DM sans', sans-serif;
}
.raiting {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    margin-bottom: -1px;
}
.raiting img {
    margin-top: 10px;
    opacity: .9;
}
.dot {
    margin-top: 17px;
    margin-left: 10px;
    margin-right: 5px;
    width: 4px;
    height: 4px;
    border-radius: 100%;
    background: rgb(100, 100, 100);
}
.raiting p:last-child {
    text-decoration: underline;
    cursor: pointer;
    color: rgb(125,125,125);
    font-weight: 300;
}
.raiting p:last-child:hover {
    color: rgb(75,75,75);
}
.btns {
    margin-top: auto;
    margin-bottom: auto;
    height: -webkit-fit-content;
    height: -moz-fit-content;
    height: fit-content;
    margin-right: 15px;
    display: flex;
    column-gap: 10px;
}
.btnsRight {
    display: flex; 
    margin-left: auto; 
    column-gap: 8px;
}
.categoryList {
    margin-left: 15px;
    margin-top: 10px;
    height: 40px;
}
.menuLinks {
    padding-top: 15px;
    padding-bottom: 15px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-column-gap: 20px;
       -moz-column-gap: 20px;
            column-gap: 20px;
    margin-left: 0px;
    font-family: 'Satoshi-Medium';
    font-size: 18px;
}
.menuLinks p {
    margin: 0;
    margin-top: 8px;
}
@media(max-width: 1730px) {
    .btnsRight {
        position: absolute;
        margin-left: 0;
        right: 20px;
    }
    .menuBody {
        width: 100%;
        padding-left: 20px;
        /* padding-left: 361px; */
    }
}
/* @media(max-width: 1150px) {
    .btnsRight {
        position: absolute;
        margin-left: 0;
        right: 20px;
    }
    .menuBody {
        padding-left: 20px;
    }
} */
/* @media(max-width: 820px) {
    .searchInput {
        width: 145px;
    }
} */
@media(max-width: 1207px) {
    .btnsRight {
        position: relative;
        margin-left: 15px;
    }
    .btnsRight button {
        white-space:nowrap;
    }
    .menuBody {
        padding-left: 20px;
        flex-wrap: nowrap;
    }
    .searchInput {
        width: 100%;
    }
}
</style>